<!-- almost deprecated used in non quote flow errors -->
<div id="wrench-error"
     class="alert alert-danger">
    <div *ngIf="errorHeader?.length > 0"
         class="text-bold text-center margin-bottom-10">
        {{errorHeader}}
    </div>
    <div *ngIf="errorMessage?.length > 0" [innerHTML]="errorMessage">
    </div>
    <div [hidden]="errorMessage?.length > 0 || errorResponseCode?.length > 0">Uh oh! Something went wrong! Please try again!</div>
    <div *ngIf="error && errorResponseCode">
        <span *ngIf="errorResponseCode == -10">Admin credentials can't be used to login to the website.</span>
        <span *ngIf="errorResponseCode == 203">Invalid username or password</span>
        <span *ngIf="errorResponseCode == 204">A user already exists with this email address. <a [routerLink]="['/login']" rel="nofollow">Login</a></span>
    </div>
    <ng-content></ng-content>
    <div>
        You can call our office at <a href='tel:+1-844-997-3624' i18n i18n-href>844-997-3624</a> for immediate assistance.
    </div>
</div>

